import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "reactstrap";
import AmazonProductListingFieldRow from "./AmazonProductListingFieldRow";
import FetchAllAssetsAsinWiseService from "../../../../../Service/OPSServices/AmazonProductListing/FetchAllAssetsAsinWiseService";
import AssetsgalleryImges from "./AssetsGalleryImges";
import { connect } from "react-redux";
import CustomModal from "../../../../Components/Modals/CustomModal";

function AmazonProductListingGroupSection(props) {
  const [galleryImg, setGalleryImg] = useState();
  const [open, setOpen] = useState(true);
  const [imagePopUpOPen, setImagePopUpOPen] = useState(false)
  const [selectedImages, setSelectedImages] = useState([]);
  const [slectedImgReplace,setSelectedReplace] = useState([]);


  useEffect(() => {
    console.log(props.fields)
    let data = {
      asin: 'B08P43P2MM'
    };
    FetchAllAssetsAsinWiseService(props.token, data).then((res) => {
      if (res) {
        setGalleryImg(res.fileList);
      }
    });
  }, []);
  const handleAction = (value) => {
    console.log(value)
    setSelectedReplace(value)
    setImagePopUpOPen(true)
  };

  const handleSubmitFile = () => {
    console.log(props.fields);
    const replaceImg=props.fields && props.fields.filter((filed)=>filed.field ==slectedImgReplace.field)
    const updatedFields = props.data.fields.map((fieldItem) => {
      if (fieldItem.field === slectedImgReplace.field) {
        return {
          ...fieldItem,
          listing: {
            ...fieldItem.listing,
            value: [selectedImages.filePath], // replace only this
          },
        };
      }
      return fieldItem; // keep everything else unchanged
    });
    console.log(updatedFields);
    props.setFields(updatedFields);  
    setImagePopUpOPen(false)
    
  }
  const handleChange = () => {

    if (props.onFieldChange) {
  
      props.onFieldChange({
  field: slectedImgReplace.field,
  value: selectedImages.filePath
});
    }
  
    setImagePopUpOPen(false);
  };


  if (!props.fields || props.fields.length === 0) return null;

  return (
    <>
      <div className="group-section-container">
        <div 
          className={`group-section-header ${open ? "is-open" : ""}`} 
          onClick={() => setOpen(!open)}
        >
          <span className="group-section-title">
            {props.title}
          </span>
          
          <span className={`group-section-arrow ${open ? "is-open" : ""}`}>
            <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 10.5V1.5C0 0.833333 0.7698 0.45523 1.3 0.85L9.1 5.35C9.56667 5.61667 9.56667 6.38333 9.1 6.65L1.3 11.15C0.7698 11.5448 0 11.1667 0 10.5Z" fill="#000000"/>
            </svg>
          </span>
        </div>

        {open && (
          <div className="group-section-body">
            <Row className="g-2 px-3 py-2 border-bottom align-items-center m-0 group-section-col-headers">
              <Col md={2}>Field</Col> 
              <Col md={3}>Catalog</Col>
              <Col md={3}>Listing</Col>
              <Col md={3}>Edit</Col>
              {/* <Col md={1}>Status</Col> */}
            </Row>
            
            <div className="group-section-scroll-container">
              {props.fields.map((f, i) => (
                <AmazonProductListingFieldRow key={f && f.field ? f.field : i} field={f} action={handleAction} 
                onFieldChange={props.onFieldChange}
                changedFields={props.changedFields}
                />
              ))}
            </div>
          </div>
        )}
      </div>

      <CustomModal
        header={"Create New Task"}
        isOpen={imagePopUpOPen}
        toggle={() => setImagePopUpOPen(!imagePopUpOPen)}
        size={"xl"}
        className='curve-popup'
      >
        <Card className='card-of-problemarea p-2'>
        <AssetsgalleryImges galleryImg={galleryImg} 
        setGalleryImg={setGalleryImg} 
        selectedImages={selectedImages}
        setSelectedImages={setSelectedImages}
        handleSubmitFile={handleChange} />
        </Card>
        </CustomModal>
    
    </>
  );
}

var mapStateToProps = function (state) {
  return { token: state.loggedUser.token };
};

export default connect(mapStateToProps)(AmazonProductListingGroupSection);